import React, { useEffect, useRef } from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { Image } from 'Components/frameworks/image/Image';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
type Props = {
  imageUrl: string;
  hint?: string;
  alt?: string;
  inert?: boolean;
};
const DIMENSIONS = {
  w: 'auto',
  h: 'auto',
};
export const Zoom = ({ imageUrl, alt = '', hint = '', inert }: Props) => {
  const { isDesktop, isRTL } = useResponsive();
  const scrollArea = useRef(null);
  useEffect(() => {
    if (isRTL && scrollArea?.current) {
      scrollArea.current.scrollLeft = scrollArea.current.scrollWidth;
    }
  });
  return (
    <div className="direction-ltr relative h-400 lg:h-full">
      {hint && !isDesktop && (
        <span className="absolute inset-x-0 top-0 mt-20 flex items-center justify-center gap-5 px-10 font-brand text-14 leading-0 text-saffron">
          <Icon width="1.25rem" name={ICONS.LIGHTBULB} />
          <span className="leading-1">{hint}</span>
        </span>
      )}
      <div
        onTouchStart={(e) => (inert ? e.stopPropagation() : null)}
        onTouchMove={(e) => (inert ? e.stopPropagation() : null)}
        onTouchEnd={(e) => (inert ? e.stopPropagation() : null)}
        className="flex h-full w-full items-center justify-start overflow-x-scroll"
        ref={scrollArea}
      >
        <Image
          classNameImg="max-w-initial max-h-initial h-full"
          hasLazyLoading={false}
          imageUrl={imageUrl}
          altMsg={alt}
          dimensions={DIMENSIONS}
          fullscreen
          transformation="resize"
          className="h-full py-20 pt-60 sm:mx-auto lg:p-0"
        />
      </div>
    </div>
  );
};
